import { render } from "./ProductsList.vue?vue&type=template&id=4cf735d4&bindings={\"loading\":\"data\",\"filters\":\"data\",\"classImageFilters\":\"data\",\"leaversImageFilters\":\"data\",\"image_options\":\"data\",\"currency\":\"options\",\"alreadyInCart\":\"options\",\"isClass\":\"options\",\"filteredProducts\":\"options\"}"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"

import "./ProductsList.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script